'use client';

import { Card, CardContent } from '@packages/shared/src/ui/Card/Card';
import type { JSX } from 'react';
import { ComponentRecognizer } from '../../components/ComponentRecognizer/ComponentRecognizer';
import type { CmsDataJsonApi } from '../../../interfaces/jsonapi';
import { SnippetTypeList } from '../../../interfaces/contentSnippet';
import { registerFlexibleComponents } from '../../components/ComponentRecognizer/registerFlexibleComponents';

// register the dynamic components
registerFlexibleComponents();

export type ServiceLayerItemProps = {
  /** json data used to render banner */
  serviceLayerData: CmsDataJsonApi;
};

/**
 * This component displays Service Layer Content on Product Detailview Pages
 *
 * @param serviceLayerData Object contains data
 * @returns JSX.Element to be placed in PageLayout
 */
const ServiceLayerItem = ({ serviceLayerData }: ServiceLayerItemProps): JSX.Element => {
  if (!serviceLayerData.data) {
    throw new Error('No data found');
  }
  return (
    <div className="_c_cms_servicelayer">
      <Card className="pb-3">
        <CardContent>
          {serviceLayerData.data.map(
            (item, index): JSX.Element | false =>
              item.type === SnippetTypeList.serviceLayerDv &&
              item.field_paragraph && (
                // The unique key is important from a performance point of view so that React doesn't have to render everything.
                // In this case it doesn't matter if only index or key is passed. The list is as it is and done.
                // eslint-disable-next-line react/no-array-index-key
                <ComponentRecognizer key={index} item={item.field_paragraph} />
              ),
          )}
        </CardContent>
      </Card>
    </div>
  );
};

// eslint-disable-next-line import-x/no-default-export
export default ServiceLayerItem;
